import React from 'react';
import { Container } from 'react-bootstrap';
import Heading from '../../../components/Ui/Heading';

const AboutUs = () => {
	return (
		<Container>
			<Heading>About us</Heading>
			<p>
				We are a renowned leading Korean cosmetics company in Bangladesh. we are
				reputedly dealing with various brands in this industry for 4 years. and
				by the time we have our own outlets in two different locations in the
				Dhaka city area. With a vision on, we will expand more with our
				authentic Korean cosmetic products.
			</p>
		</Container>
	);
};

export default AboutUs;
